// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "机器人工程专业导论",
      "tec": "祝尚臻",
      "week": "12-15周",
      "add": "教学楼B座120自控"
    },
    [
      {
        "sub": "大学英语（一）",
        "tec": "王晓红",
        "week": "6-9,11-18周",
        "add": "教学楼B座221自控"
      },
      {
        "sub": "26自机1-2",
        "tec": "单韧",
        "week": "6-9,11-18周",
        "add": "教学楼B座319能动"
      },
      {
        "sub": "26自机2-4",
        "tec": "丁璐瑶",
        "week": "6-9,11-18周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "26自机1-1",
        "tec": "刘亚梅",
        "week": "6-9,11-18周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "26自机1-3",
        "tec": "杨丹丹",
        "week": "6-9,11-18周",
        "add": "教学楼B座220能动"
      },
      {
        "sub": "26自机2-3",
        "tec": "徐常翠",
        "week": "6-9,11-18周",
        "add": "教学楼B座219能动"
      },
      {
        "sub": "26自机2-1",
        "tec": "苏欣",
        "week": "6-9,11-18周",
        "add": "教学楼D座226经管"
      }
    ],
    {
      "sub": "人工智能与计算思维",
      "tec": "王永峰",
      "week": "6,8,10,12,14周",
      "add": "教学楼B座119自控"
    },
    0,
    {
      "sub": "形势与政策",
      "tec": "单超",
      "week": "6-9周",
      "add": "教学楼C座213教务"
    }
  ],
  "2": [
    {
      "sub": "高等数学（一）",
      "tec": "张娇",
      "week": "6-9,11-18周",
      "add": "教学楼C座213教务"
    },
    {
      "sub": "军事理论",
      "tec": "霍萧冉",
      "week": "6-9,11-15周",
      "add": "教学楼C座306教务"
    },
    {
      "sub": "体育（一）",
      "tec": "樊绍斌",
      "week": "7-18周",
      "add": "（7-18周[05-06节]）"
    },
    0,
    0
  ],
  "3": [
    {
      "sub": "思想道德与法治",
      "tec": "曹媛媛",
      "week": "6-9,11-18周",
      "add": "教学楼A座426机械"
    },
    {
      "sub": "高等数学（一）",
      "tec": "张娇",
      "week": "6-9,11-18周",
      "add": "教学楼C座213教务"
    },
    0,
    0,
    0
  ],
  "4": [
    [
      {
        "sub": "大学英语（一）",
        "tec": "苏欣",
        "week": "6-9,11-18周",
        "add": "实训楼E座310"
      },
      {
        "sub": "26自机2-2",
        "tec": "丁璐瑶",
        "week": "6-9,11-18周",
        "add": "教学楼B座119自控"
      },
      {
        "sub": "26自机1-1",
        "tec": "刘亚梅",
        "week": "6-9,11-18周",
        "add": "教学楼B座220能动"
      },
      {
        "sub": "26自机1-3",
        "tec": "单韧",
        "week": "6-9,11-18周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "26自机2-4",
        "tec": "徐常翠",
        "week": "6-9,11-18周",
        "add": "实训楼E座302语音室"
      },
      {
        "sub": "26自机2-1",
        "tec": "杨丹丹",
        "week": "6-9,11-18周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "26自机2-3",
        "tec": "王晓红",
        "week": "6-9,11-18周",
        "add": "实训楼Ｅ座501语音室"
      }
    ],
    [
      {
        "sub": "人工智能与计算思维",
        "tec": "王永峰",
        "week": "6,8,10,12,14周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "人工智能与计算思维",
        "tec": "王永峰",
        "week": "7,9,11,13,15,17周",
        "add": "实训楼C座303"
      }
    ],
    {
      "sub": "就业创业指导",
      "tec": "霍萧冉",
      "week": "6-10周",
      "add": "教学楼C座111教务"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "高等数学（一）",
      "tec": "张娇",
      "week": "6-9,11-18周",
      "add": "教学楼C座113教务"
    },
    {
      "sub": "机器人工程专业导论",
      "tec": "祝尚臻",
      "week": "12-15周",
      "add": "教学楼C座114教务"
    },
    {
      "sub": "思想道德与法治",
      "tec": "曹媛媛",
      "week": "6-9,11-18周",
      "add": "教学楼A座426机械"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
